function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlpineCheckboxUnchecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "alpine-checkbox-unchecked",
    d: "M28.444,3.556L28.444,28.444L3.556,28.444L3.556,3.556L28.444,3.556ZM28.444,0L3.556,0C1.6,0 0,1.6 0,3.556L0,28.444C0,30.4 1.6,32 3.556,32L28.444,32C30.4,32 32,30.4 32,28.444L32,3.556C32,1.6 30.4,0 28.444,0Z",
    style: {
      fillRule: "nonzero"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlpineCheckboxUnchecked);
export default __webpack_public_path__ + "static/media/alpine-checkbox-unchecked.924113b9f529d1e294d475309ed9444a.svg";
export { ForwardRef as ReactComponent };